import {storeSet, authPageCheck} from "@/mixins/Auth.js";

function setViewResolver(component) {
    return require("../views/" + component).default;
}

const layout = {
    render(h) {
        return h("router-view");
    },
};

export default [
    {
        path: "/",
        component: setViewResolver("Home"),
        name: "Home",
        beforeEnter: storeSet,
        meta: {
            name: "Main",
            title: "홈",
            sideName: "홈",
            sideHidden: true,
            authRequired: true,
        },
        redirect: "/student/member",
    },
    {
        path: "/auth",
        component: setViewResolver("auth/Login"),
        name: "Auth",
        beforeEnter: authPageCheck,
        meta: {title: "로그인", sideName: "로그인", sideHidden: true},
    },
    {
        path: "/policy",
        component: setViewResolver("auth/Policy"),
        meta: {title: "개인정보취급방침", sideHidden: true},
        name: "Policy",
    },
    {
        path: "/student",
        component: setViewResolver("RouteView"),
        name: "Member",
        meta: {name: "Member", sideName: "학생관리", title: "회원관리"},
        children: [
            {
                path: "member",
                component: setViewResolver("member/Member"),
                name: "MemberList",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberList",
                    title: "회원리스트",
                    sideName: "회원리스트",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "member/:m_idx",
                component: setViewResolver("member/MemberDetail"),
                name: "MemberDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberDetail",
                    title: "회원상세",
                    sideName: "회원상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "quit",
                component: setViewResolver("member/MemberQuit"),
                name: "MemberQuit",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberQuit",
                    title: "탈퇴회원",
                    sideName: "탈퇴회원",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "premium",
                component: setViewResolver("member/MemberPremium"),
                name: "MemberPremium",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberPremium",
                    title: "추가프리미엄",
                    sideName: "추가프리미엄",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "premium/create",
                component: setViewResolver("member/MemberPremiumCreate"),
                name: "MemberPremiumCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberPremiumCreate",
                    title: "프리미엄 회원 추가",
                    sideName: "프리미엄 회원 추가",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "premium/:m_idx",
                component: setViewResolver("member/MemberPremiumDetail"),
                name: "MemberPremiumDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberPremiumDetail",
                    title: "프리미엄 회원 수정",
                    sideName: "프리미엄 회원 수정",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/content",
        component: setViewResolver("RouteView"),
        name: "Content",
        meta: {name: "Content", sideName: "학습관리", title: "학습관리"},
        children: [
            {
                path: "categories",
                component: setViewResolver("content/Categories"),
                name: "Categories",
                beforeEnter: storeSet,
                meta: {
                    name: "Categories",
                    title: "카테고리관리",
                    sideName: "카테고리관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content",
                component: setViewResolver("content/Content"),
                name: "Content",
                beforeEnter: storeSet,
                meta: {
                    name: "Content",
                    title: "콘텐츠관리",
                    sideName: "콘텐츠관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content/create",
                component: setViewResolver("content/ContentCreate"),
                name: "ContentCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentCreate",
                    title: "콘텐츠등록",
                    sideName: "콘텐츠등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content/:idx",
                component: setViewResolver("content/ContentUpdate"),
                name: "ContentUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentUpdate",
                    title: "콘텐츠상세",
                    sideName: "콘텐츠상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "comment",
                component: setViewResolver("content/Comment"),
                name: "Comment",
                beforeEnter: storeSet,
                meta: {
                    name: "Content",
                    title: "콘텐츠댓글관리",
                    sideName: "콘텐츠댓글관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "comment/:idx",
                component: setViewResolver("content/CommentDetail"),
                name: "CommentDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "CommentDetail",
                    title: "콘텐츠댓글상세",
                    sideName: "콘텐츠댓글상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "language",
                component: setViewResolver("onlineLanguage/OnlineLanguage"),
                name: "OnlineLanguage",
                beforeEnter: storeSet,
                meta: {
                    name: "OnlineLanguage",
                    title: "Korean Practice 관리",
                    sideName: "Korean Practice 관리",
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "freeTalk",
                component: setViewResolver("freeTalk/FreeTalk"),
                name: "FreeTalk",
                beforeEnter: storeSet,
                meta: {
                    name: "FreeTalk",
                    title: "Free-talking 관리",
                    sideName: "Free-talking 관리",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "topic",
                component: setViewResolver("topic/Topic"),
                name: "Topic",
                beforeEnter: storeSet,
                meta: {
                    name: "Topic",
                    title: "주제",
                    sideName: "주제",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "topic/create",
                component: setViewResolver("topic/TopicCreate"),
                name: "TopicCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "TopicCreate",
                    title: "주제 등록",
                    sideName: "주제 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "topic/:idx",
                component: setViewResolver("topic/TopicDetail"),
                name: "TopicDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "TopicDetail",
                    title: "주제 상세",
                    sideName: "주제 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "category",
                component: setViewResolver("category/Category"),
                name: "Category",
                beforeEnter: storeSet,
                meta: {
                    name: "Category",
                    title: "분야 관리",
                    sideName: "분야 관리",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "expression",
                component: setViewResolver("expression/Expression"),
                name: "Expression",
                beforeEnter: storeSet,
                meta: {
                    name: "Expression",
                    title: "표현",
                    sideName: "표현",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "expression/create",
                component: setViewResolver("expression/ExpressionCreate"),
                name: "ExpressionCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "ExpressionCreate",
                    title: "표현 등록",
                    sideName: "표현 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "expression/:idx",
                component: setViewResolver("expression/ExpressionDetail"),
                name: "ExpressionDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "ExpressionDetail",
                    title: "표현 상세",
                    sideName: "표현 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            // {
            //   path: "expression",
            //   component: setViewResolver("expression/Expression"),
            //   name: "Expression",
            //   beforeEnter: storeSet,
            //   meta: {
            //     name: "Expression",
            //     title: "표현",
            //     sideName: "표현",
            //     sideHidden: true,
            //     authRequired: true,
            //   },
            // },
            // {
            //   path: "expression/create",
            //   component: setViewResolver("expression/ExpressionCreate"),
            //   name: "ExpressionCreate",
            //   beforeEnter: storeSet,
            //   meta: {
            //     name: "ExpressionCreate",
            //     title: "표현 등록",
            //     sideName: "표현 등록",
            //     sideHidden: true,
            //     authRequired: true,
            //   },
            // },
            // {
            //   path: "expression/:idx",
            //   component: setViewResolver("expression/ExpressionDetail"),
            //   name: "ExpressionDetail",
            //   beforeEnter: storeSet,
            //   meta: {
            //     name: "ExpressionDetail",
            //     title: "표현 상세",
            //     sideName: "표현 상세",
            //     sideHidden: true,
            //     authRequired: true,
            //   },
            // },
            {
                path: "CategoryExpression",
                component: setViewResolver("category/CategoryExpression"),
                name: "CategoryExpression",
                beforeEnter: storeSet,
                meta: {
                    name: "CategoryExpression",
                    title: "표현 관리",
                    sideName: "표현 관리",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "liveklass",
                component: setViewResolver("liveklass/LiveKlass"),
                name: "LiveKlass",
                beforeEnter: storeSet,
                meta: {
                    name: "Categories",
                    title: "Real Class 관리",
                    sideName: "Real Class 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "liveklass/adjust",
                component: setViewResolver("liveklass/LiveKlassAdjust"),
                name: "LiveKlassAdjust",
                beforeEnter: storeSet,
                meta: {
                    name: "Categories",
                    title: "Real Class 관리",
                    sideName: "Real Class 관리",
                    authRequired: true,
                    sideHidden: true,
                    storeRequired: true,
                },
            },
            {
                path: "liveklass/create",
                component: setViewResolver("liveklass/LiveKlassCreate"),
                name: "LiveclassCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveclassCreate",
                    title: "Real Class 등록",
                    sideName: "Real Class 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            }, {
                path: "liveklass/:idx",
                component: setViewResolver("liveklass/LiveKlassDetail"),
                name: "LiveclassDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveKlassDetail",
                    title: "Real Class 상세",
                    sideName: "Real Class 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            }, {
                path: "liveklass/:idx/streaming",
                component: setViewResolver("liveklass/LiveKlassDetailStreaming"),
                name: "LiveKlassDetailStreaming",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveKlassDetail",
                    title: "Real Class 상세",
                    sideName: "Real Class 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            }, {
                path: "liveklass/:idx/streaming/create",
                component: setViewResolver("streaming/LiveKlassStreamingCreate"),
                name: "LiveKlassStreamingCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveKlassStreamingCreate",
                    title: "스트리밍 등록",
                    sideName: "스트리밍 등록",
                    authRequired: true,
                    sideHidden: true,
                    storeRequired: true,
                },
            }, {
                path: "liveklass/:idx/streaming/:s_idx",
                component: setViewResolver("streaming/LiveKlassStreamingDetail"),
                name: "LiveKlassStreamingDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "streaming", title: "스트리밍 상세", sideName: "스트리밍 상세", authRequired: true, sideHidden: true, storeRequired: true,
                },
            },
            {
                path: "liveklass/:idx/streaming/:s_idx/student",
                component: setViewResolver("streaming/LiveKlassStreamingDetailStudent"),
                name: "LiveKlassStreamingDetailStudent",
                beforeEnter: storeSet,
                meta: {
                    name: "streaming", title: "스트리밍 상세", sideName: "스트리밍 상세", authRequired: true, sideHidden: true, storeRequired: true,
                },
            },
            {
                path: "liveklass/adjust/:idx",
                component: setViewResolver("liveklass/LiveKlassAdjustDetail"),
                name: "LiveKlassAdjustDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveKlassAdjustDetail",
                    title: "Class 수익 상세",
                    sideName: "Class 수익 상세",
                    authRequired: true,
                    sideHidden: true,
                    storeRequired: true,
                },
            },
            {
                path: "correction",
                component: setViewResolver("correction/Correction"),
                name: "Correction",
                beforeEnter: storeSet,
                meta: {
                    name: "Correction",
                    sideName: "첨삭관리",
                    title: "첨삭관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/streamingmanage",
        component: setViewResolver("RouteView"),
        name: "스트리밍&레귤러 관리",
        beforeEnter: storeSet,
        meta: {
            name: "streamingRegular",
            sideName: "스트리밍&레귤러 관리",
            title: "스트리밍&레귤러 관리",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
        children: [
            {
                path: "streaming",
                component: setViewResolver("streaming/Streaming"),
                name: "스트리밍 관리",
                beforeEnter: storeSet,
                meta: {
                    name: "streaming",
                    title: "스트리밍 관리",
                    sideName: "스트리밍 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "streaming/create",
                component: setViewResolver("streaming/StreamingCreate"),
                name: "StreamingCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "streaming",
                    title: "스트리밍 등록",
                    sideName: "스트리밍 등록",
                    authRequired: true,
                    storeRequired: true,
                    sideHidden: true,
                },
            },
            {
                path: "regularcate",
                component: setViewResolver("streaming/RegularCategory"),
                name: "레귤러 카테고리 관리",
                beforeEnter: storeSet,
                meta: {
                    name: "Regular",
                    title: "레귤러 카테고리 관리",
                    sideName: "레귤러 카테고리 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "regularcontent",
                component: setViewResolver("streaming/RegularContent"),
                name: "레귤러 콘텐츠 관리",
                beforeEnter: storeSet,
                meta: {
                    name: "Regular",
                    title: "레귤러 콘텐츠 관리",
                    sideName: "레귤러 콘텐츠 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "regularcontent/create/:s_idx",
                component: setViewResolver("streaming/RegularCreate"),
                name: "레귤러 콘텐츠 등록",
                beforeEnter: storeSet,
                meta: {
                    name: "Regular",
                    title: "레귤러 콘텐츠 등록",
                    sideName: "레귤러 콘텐츠 등록",
                    authRequired: true,
                    storeRequired: true,
                    sideHidden: true,
                },
            },
            {
                path: "regularcontent/:c_idx",
                component: setViewResolver("streaming/RegularUpdate"),
                name: "레귤러 콘텐츠 수정",
                beforeEnter: storeSet,
                meta: {
                    name: "Regular",
                    title: "레귤러 콘텐츠 수정",
                    sideName: "레귤러 콘텐츠 수정",
                    authRequired: true,
                    storeRequired: true,
                    sideHidden: true,
                },
            },
            {
                path: "streaming/:s_idx",
                component: setViewResolver("streaming/StreamingDetail"),
                name: "스트리밍 상세",
                beforeEnter: storeSet,
                meta: {
                    name: "streaming",
                    title: "스트리밍 상세",
                    sideName: "스트리밍 상세",
                    authRequired: true,
                    storeRequired: true,
                    sideHidden: true,
                },
            },
        ],
    },
    {
        path: "/ssamtalk",
        component: setViewResolver("RouteView"),
        name: "SSamTalk",
        beforeEnter: storeSet,
        meta: {
            name: "SSamTalk",
            sideName: "AI Speaking 관리",
            title: "AI Speaking 관리",
            authRequired: true,
            storeRequired: true,
        },
        children: [
            {
                path: "categories",
                component: setViewResolver("ssamtalk/SsamTalkCategory"),
                name: "SsamTalkCategory",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkCategory",
                    title: "카테고리 관리",
                    sideName: "카테고리 관리",
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "categories/create",
                component: setViewResolver("ssamtalk/SsamTalkCategoryCreate"),
                name: "SsamTalkCategoryCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkCategoryCreate",
                    title: "카테고리 생성",
                    sideName: "카테고리 생성",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "categories/:idx",
                component: setViewResolver("ssamtalk/SsamTalkCategoryDetail"),
                name: "SsamTalkCategoryDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkCategoryDetail",
                    title: "카테고리 수정",
                    sideName: "카테고리 수정",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content",
                component: setViewResolver("ssamtalk/SsamTalkContent"),
                name: "SsamTalkContent",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkContent",
                    title: "AI Speaking 관리",
                    sideName: "AI Speaking 관리",
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content/create",
                component: setViewResolver("ssamtalk/SsamTalkContentCreate"),
                name: "SsamTalkContentCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkContentCreate",
                    title: "AI Speaking 등록",
                    sideName: "AI Speaking 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content/:idx",
                component: setViewResolver("ssamtalk/SsamTalkContentDetail"),
                name: "SsamTalkContentDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkContentDetail",
                    title: "AI Speaking 상세",
                    sideName: "AI Speaking 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "content/:idx/step",
                component: setViewResolver("ssamtalk/SsamTalkStep"),
                name: "SsamTalkStep",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamTalkStep",
                    title: "STEP 목록",
                    sideName: "STEP 목록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/chatLog",
        component: setViewResolver("RouteView"),
        name: "ChatLog",
        beforeEnter: storeSet,
        meta: {
            name: "ChatLog",
            sideName: "화상 채팅 관리",
            title: "화상 채팅 관리",
            authRequired: true,
            storeRequired: true,
        },
        children: [
            {
                path: "",
                component: setViewResolver("chat/Log"),
                name: "ChatLog",
                beforeEnter: storeSet,
                meta: {
                    name: "ChatLog",
                    title: "로그 및 히스토리",
                    sideName: "로그 및 히스토리",
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: ":date",
                component: setViewResolver("chat/LogDaily"),
                name: "ChatLogDaily",
                beforeEnter: storeSet,
                meta: {
                    name: "ChatLogDaily",
                    title: "로그 및 히스토리",
                    sideName: "로그 및 히스토리",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/ksquare",
        component: setViewResolver("RouteView"),
        name: "KSquare",
        meta: {
            name: "KSquare",
            sideName: "K-SQUARE 관리",
            title: "K-SQUARE 관리",
        },
        children: [
            {
                path: "ssams",
                component: setViewResolver("ssams/Ssams"),
                name: "Ssams",
                beforeEnter: storeSet,
                meta: {
                    name: "Ssams",
                    title: "SsamSsam 관리",
                    sideName: "SsamSsam 관리",
                    sideHidden: false,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "sns",
                component: setViewResolver("content/UserContent"),
                name: "UserContent",
                beforeEnter: storeSet,
                meta: {
                    name: "UserContent",
                    title: "Visual Exchange 관리",
                    sideName: "Visual Exchange 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ktalk",
                component: setViewResolver("content/KTalkContent"),
                name: "UserContent",
                beforeEnter: storeSet,
                meta: {
                    name: "UserContent",
                    title: "Open Board 관리",
                    sideName: "Open Board 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },

            {
                path: "ssams/create",
                component: setViewResolver("ssams/SsamsCreate"),
                name: "SsamsCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsCreate",
                    title: "SsamSsam 등록",
                    sideName: "SsamSsam 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/content/:idx",
                component: setViewResolver("ssams/SsamsContentDetail"),
                name: "Ssams",
                beforeEnter: storeSet,
                meta: {
                    name: "Ssams",
                    title: "SsamSsam 콘텐츠",
                    sideName: "SsamSsam 콘텐츠",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/Ktalk/:idx",
                component: setViewResolver("ssams/SsamsKoreanTalkDetail"),
                name: "Ssams",
                beforeEnter: storeSet,
                meta: {
                    name: "Ssams",
                    title: "SsamSsam QNA",
                    sideName: "SsamSsam QNA",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/ssamsUpdate",
                component: setViewResolver("ssams/SsamsUpdate"),
                name: "SsamsUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsUpdate",
                    title: "SsamSsam 상세",
                    sideName: "SsamSsam 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/ssamsContent",
                component: setViewResolver("ssams/SsamsContent"),
                name: "SsamsContent",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsContent",
                    title: "Ssam 콘텐츠",
                    sideName: "Ssam 콘텐츠",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/ssamsContent/:wr_id",
                component: setViewResolver("ssams/SsamsContentDetail"),
                name: "SsamsContentDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsContentDetail",
                    title: "Ssam 콘텐츠 상세",
                    sideName: "Ssam 콘텐츠 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/SsamsKoreanTalk",
                component: setViewResolver("ssams/SsamsKoreanTalk"),
                name: "SsamsKoreanTalk",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsKoreanTalk",
                    title: "Ssam Q&A",
                    sideName: "Ssam Q&A",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ssams/:s_idx/SsamsKoreanTalk/:wr_id",
                component: setViewResolver("ssams/SsamsKoreanTalkDetail"),
                name: "SsamsKoreanTalkDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "SsamsKoreanTalkDetail",
                    title: "Ssam Q&A 상세",
                    sideName: "Ssam Q&A 상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/ksquare/sns/:idx",
        component: setViewResolver("content/UserContentDetail"),
        name: "UserContentDetail",
        beforeEnter: storeSet,
        meta: {
            name: "UserContentDetail",
            title: "콘텐츠상세",
            sideName: "콘텐츠상세",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: "/ksquare/ktalk/:idx",
        component: setViewResolver("content/KTalkContentDetail"),
        name: "UserContentDetail",
        beforeEnter: storeSet,
        meta: {
            name: "UserContentDetail",
            title: "콘텐츠상세",
            sideName: "콘텐츠상세",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: '/item',
        component: setViewResolver('RouteView'),
        name: 'Content',
        meta: {name: 'Content', sideName: 'KOIN 관리', title: 'KOIN 관리'},
        children: [
            {
                path: 'koin',
                component: setViewResolver('koin/Koin'),
                name: 'Content',
                beforeEnter: storeSet,
                meta: {name: 'Content', title: '사용내역', sideName: '사용내역', authRequired: true, storeRequired: true,},
            },
            {
                path: 'item',
                component: setViewResolver('item/Item'),
                name: 'Content',
                beforeEnter: storeSet,
                meta: {name: 'Content', title: '상품관리', sideName: '상품관리', authRequired: true, storeRequired: true,},
            },
            {
                path: 'item/create',
                component: setViewResolver('item/ItemCreate'),
                name: 'ContentCreate',
                beforeEnter: storeSet,
                meta: {name: 'ContentCreate', title: '상품등록', sideName: '상품등록', sideHidden: true, authRequired: true, storeRequired: true,},
            },
            {
                path: 'item/:idx',
                component: setViewResolver('item/ItemUpdate'),
                name: 'ContentUpdate',
                beforeEnter: storeSet,
                meta: {name: 'ContentUpdate', title: '상품상세', sideName: '상품상세', sideHidden: true, authRequired: true, storeRequired: true,},
            },
        ]
    },
    {
        path: "/correction/update/:idx",
        component: setViewResolver("correction/CorrectionUpdate"),
        name: "CorrectionUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "CorrectionUpdate",
            title: "첨삭상세정보",
            sideName: "첨삭상세정보",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: "/correction/recreate/:idx",
        component: setViewResolver("correction/CorrectionReCreate"),
        name: "CorrectionReCreate",
        beforeEnter: storeSet,
        meta: {
            name: "CorrectionReCreate",
            title: "첨삭상세정보",
            sideName: "첨삭상세정보",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: "/correction/reupdate/:idx",
        component: setViewResolver("correction/CorrectionReUpdate"),
        name: "CorrectionReUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "CorrectionReUpdate",
            title: "첨삭상세정보",
            sideName: "첨삭상세정보",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: "/correction/:idx",
        component: setViewResolver("correction/CorrectionDetail"),
        name: "CorrectionDetail",
        beforeEnter: storeSet,
        meta: {
            name: "CorrectionDetail",
            title: "첨삭상세정보",
            sideName: "첨삭상세정보",
            sideHidden: true,
            authRequired: true,
            storeRequired: true,
        },
    },
    {
        path: "/payment",
        component: setViewResolver("RouteView"),
        name: "PaymentView",
        meta: {name: "Payment", sideName: "결제관리", title: "결제관리"},
        children: [
            {
                path: "",
                component: setViewResolver("payment/Payment"),
                name: "Payment",
                beforeEnter: storeSet,
                meta: {
                    name: "Payment",
                    sideName: "결제관리",
                    title: "결제관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "refund",
                component: setViewResolver("refund/Refund"),
                name: "Refund",
                beforeEnter: storeSet,
                meta: {
                    name: "Refund",
                    sideName: "환불관리",
                    title: "환불관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "refund/:idx",
                component: setViewResolver("refund/RefundDetail"),
                name: "RefundDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "RefundDetail",
                    sideName: "환불관리상세",
                    title: "환불관리상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "coupon",
                component: setViewResolver("coupon/Coupon"),
                name: "Coupon",
                beforeEnter: storeSet,
                meta: {
                    name: "Coupon",
                    sideName: "쿠폰관리",
                    title: "쿠폰관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "coupon/create",
                component: setViewResolver("coupon/CouponCreate"),
                name: "CouponCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "CouponCreate",
                    sideName: "쿠폰추가",
                    title: "쿠폰추가",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "coupon/:idx",
                component: setViewResolver("coupon/CouponDetail"),
                name: "CouponDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "CouponDetail",
                    sideName: "쿠폰관리상세",
                    title: "쿠폰관리상세",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/main",
        component: setViewResolver("RouteView"),
        name: "Main",
        meta: {name: "Main", sideName: "메인관리", title: "메인관리"},
        children: [
            {
                path: "banner",
                component: setViewResolver("banner/Banner"),
                name: "MainBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "MainBanner",
                    sideName: "배너 관리",
                    title: "배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "banner/popup",
                component: setViewResolver("popupBanner/PopupBanner"),
                name: "PopupBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "PopupBanner",
                    sideName: "팝업 배너 관리",
                    title: "팝업 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "leveltest",
                component: setViewResolver("level/LevelTest"),
                name: "MainLevelTest",
                beforeEnter: storeSet,
                meta: {
                    name: "MainLevelTest",
                    sideName: "테스트 관리",
                    title: "테스트 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "file",
                component: setViewResolver("image/Level"),
                name: "MainImageLevel",
                beforeEnter: storeSet,
                meta: {
                    name: "MainImageLevel",
                    sideName: "테스트 배너 관리",
                    title: "테스트 배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "banner/liveclass",
                component: setViewResolver("liveklass/LiveclassBanner"),
                name: "LiveBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveBanner",
                    sideName: "Real Class 배너 관리",
                    title: "Real Class 배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "banner/chat",
                component: setViewResolver("banner/ChatBanner"),
                name: "ChatBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "ChatBanner",
                    sideName: "Chat 배너 관리",
                    title: "Chat 배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "banner/freeTalking",
                component: setViewResolver("banner/FreeTalkingBanner"),
                name: "FreeTalkingBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "FreeTalkingBanner",
                    sideName: "FreeTalking 배너 관리",
                    title: "FreeTalking 배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "banner/koreanSpeaking",
                component: setViewResolver("banner/KoreanSpeakingBanner"),
                name: "KoreanSpeakingBanner",
                beforeEnter: storeSet,
                meta: {
                    name: "KoreanSpeakingBanner",
                    sideName: "KoreanSpeaking 배너 관리",
                    title: "KoreanSpeaking 배너 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "ucc",
                component: setViewResolver("ucc/MainUcc"),
                name: "MainUcc",
                beforeEnter: storeSet,
                meta: {
                    name: "MainUcc",
                    sideName: "우수 UCC",
                    title: "우수 UCC",
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/board",
        component: setViewResolver("RouteView"),
        name: "Board",
        meta: {name: "Board", sideName: "고객센터관리", title: "고객센터관리"},
        children: [
            {
                path: "qna",
                component: setViewResolver("qna/Qna"),
                name: "Qna",
                beforeEnter: storeSet,
                meta: {
                    name: "Qna",
                    title: "1:1 문의 관리",
                    sideName: "1:1 문의 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "qna/create/:idx",
                component: setViewResolver("qna/QnaCreate"),
                name: "QnaCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "QnaCreate",
                    title: "1:1 문의 상세정보",
                    sideName: "1:1 문의 상세정보",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "qna/:idx",
                component: setViewResolver("qna/QnaDetail"),
                name: "QnaDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "QnaDetail",
                    title: "1:1 문의 상세정보",
                    sideName: "1:1 문의 상세정보",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "declaration",
                component: setViewResolver("RouteView"),
                name: "Declaration",
                beforeEnter: storeSet,
                meta: {
                    name: "Declaration",
                    title: "신고 관리",
                    sideName: "신고 관리",
                    authRequired: true,
                    storeRequired: true,
                },
                children: [
                    {
                        path: "board",
                        component: setViewResolver("declaration/DeclarationBoard"),
                        name: "DeclarationBoard",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationBoard",
                            title: "Visual Exchange & 쌤즈콘텐츠",
                            sideName: "Visual Exchange & 쌤즈콘텐츠",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "reply",
                        component: setViewResolver("declaration/DeclarationReply"),
                        name: "DeclarationReply",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationReply",
                            title: "Visual Exchange & 쌤즈콘텐츠 댓글",
                            sideName: "Visual Exchange & 쌤즈콘텐츠 댓글",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "koreantalk",
                        component: setViewResolver("declaration/DeclarationKoreanTalk"),
                        name: "DeclarationBoard",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationBoard",
                            title: "User Board & 쌤즈Q&A",
                            sideName: "User Board & 쌤즈Q&A",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "koreantalkreply",
                        component: setViewResolver(
                            "declaration/DeclarationKoreanTalkComment"
                        ),
                        name: "DeclarationReply",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationReply",
                            title: "User Board & 쌤즈Q&A 댓글",
                            sideName: "User Board & 쌤즈Q&A 댓글",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "content",
                        component: setViewResolver("declaration/DeclarationContent"),
                        name: "DeclarationContent",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationContent",
                            title: "학습콘텐츠댓글",
                            sideName: "학습콘텐츠댓글",
                            authRequired: true,
                            sideHidden: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "chat",
                        component: setViewResolver("declaration/DeclarationChat"),
                        name: "DeclarationChat",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationChat",
                            title: "채팅방",
                            sideName: "채팅방",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "chat/:idx",
                        component: setViewResolver("declaration/DeclarationChatDetail"),
                        name: "DeclarationChatDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationChatDetail",
                            title: "채팅 상세",
                            sideName: "채팅 상세",
                            authRequired: true,
                            sideHidden: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "openChat",
                        component: setViewResolver("declaration/DeclarationSsamsOpenChat"),
                        name: "DeclarationSsamsOpenChat",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationSsamsOpenChat",
                            title: "쌤즈 오픈채팅방",
                            sideName: "쌤즈 오픈채팅방",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "openChat/:idx",
                        component: setViewResolver("declaration/DeclarationSsamsOpenChatDetail"),
                        name: "DeclarationSsamsOpenChatDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DeclarationSsamsOpenChatDetail",
                            title: "쌤즈 오픈채팅 상세",
                            sideName: "쌤즈 오픈채팅 상세",
                            authRequired: true,
                            sideHidden: true,
                            storeRequired: true,
                        },
                    },
                ],
            },
            {
                path: "notice",
                component: setViewResolver("notice/Notice"),
                name: "Notice",
                beforeEnter: storeSet,
                meta: {
                    name: "Notice",
                    title: "공지사항 관리",
                    sideName: "공지사항 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "notice/create",
                component: setViewResolver("notice/NoticeCreate"),
                name: "NoticeCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "NoticeCreate",
                    title: "공지사항 등록",
                    sideName: "공지사항 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "notice/:idx",
                component: setViewResolver("notice/NoticeUpdate"),
                name: "NoticeUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "NoticeUpdate",
                    title: "공지사항 수정",
                    sideName: "공지사항 수정",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "faq",
                component: setViewResolver("faq/Faq"),
                name: "Faq",
                beforeEnter: storeSet,
                meta: {
                    name: "Faq",
                    title: "FAQ 관리",
                    sideName: "FAQ 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "faq/create",
                component: setViewResolver("faq/FaqCreate"),
                name: "FaqCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "FaqCreate",
                    title: "FAQ 등록",
                    sideName: "FAQ 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "faq/:idx",
                component: setViewResolver("faq/FaqUpdate"),
                name: "FaqUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "FaqUpdate",
                    title: "FAQ 수정",
                    sideName: "FAQ 수정",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "event",
                component: setViewResolver("event/Event"),
                name: "Event",
                beforeEnter: storeSet,
                meta: {
                    name: "Event",
                    title: "이벤트 관리",
                    sideName: "이벤트 관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "event/create",
                component: setViewResolver("event/EventCreate"),
                name: "EventCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "EventCreate",
                    title: "이벤트 등록",
                    sideName: "이벤트 등록",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "event/:idx",
                component: setViewResolver("event/EventUpdate"),
                name: "EventUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "EventUpdate",
                    title: "이벤트 수정",
                    sideName: "이벤트 수정",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },

            {
                path: "terms",
                component: setViewResolver("RouteView"),
                name: "Terms",
                meta: {name: "Terms", sideName: "약관 관리", title: "약관 관리"},
                children: [
                    {
                        path: "service",
                        component: setViewResolver("terms/TermsService"),
                        name: "TermsService",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsService",
                            title: "서비스이용약관",
                            sideName: "서비스이용약관",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "privacy",
                        component: setViewResolver("terms/TermsPrivacy"),
                        name: "TermsPrivacy",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsPrivacy",
                            title: "개인정보처리방침",
                            sideName: "개인정보처리방침",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "quit",
                        component: setViewResolver("terms/TermsQuit"),
                        name: "TermsQuit",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsQuit",
                            title: "회원탈퇴약관",
                            sideName: "회원탈퇴약관",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: "payment",
                        component: setViewResolver("terms/TermsPayment"),
                        name: "TermsPayment",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsPayment",
                            title: "결제약관",
                            sideName: "결제약관",
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                    {
                        path: ":terms/:type",
                        component: setViewResolver("terms/TermsDetail"),
                        name: "TermsDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsDetail",
                            title: "약관상세",
                            sideName: "약관상세",
                            sideHidden: true,
                            authRequired: true,
                            storeRequired: true,
                        },
                    },
                ],
            },
            {
                path: "mail",
                component: setViewResolver("mail/Mail"),
                name: "Mail",
                beforeEnter: storeSet,
                meta: {
                    name: "Mail",
                    title: "메일발송",
                    sideName: "메일발송",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "mail/send",
                component: setViewResolver("mail/MailSend"),
                name: "MailSend",
                beforeEnter: storeSet,
                meta: {
                    name: "MailSend",
                    title: "메일발송",
                    sideName: "메일발송",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "mail/:idx",
                component: setViewResolver("mail/MailDetail"),
                name: "MailDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MailDetail",
                    title: "메일상세정보",
                    sideName: "메일상세정보",
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "push",
                component: setViewResolver("push/Push"),
                name: "Push",
                beforeEnter: storeSet,
                meta: {
                    name: "Push",
                    title: "푸시관리",
                    sideName: "푸시관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "push/create",
                component: setViewResolver("push/PushCreate"),
                name: "PushCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "PushCreate",
                    title: "푸시 등록",
                    sideName: "푸시 등록",
                    authRequired: true,
                    sideHidden: true,
                    storeRequired: true,
                },
            },
            {
                path: "push/:idx",
                component: setViewResolver("push/PushDetail"),
                name: "PushDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "PushDetail",
                    title: "푸시 상세",
                    sideName: "푸시 상세",
                    authRequired: true,
                    sideHidden: true,
                    storeRequired: true,
                },
            },
            {
                path: "scheduler",
                component: setViewResolver("push/PushScheduler"),
                name: "PushScheduler",
                beforeEnter: storeSet,
                meta: {
                    name: "PushScheduler",
                    title: "푸시스케줄러관리",
                    sideName: "푸시스케줄러관리",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "scheduler/:idx",
                component: setViewResolver("push/PushSchedulerDetail"),
                name: "PushSchedulerDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "PushSchedulerDetail",
                    title: "푸시 스케줄러 상세",
                    sideName: "푸시 스케줄러 상세",
                    authRequired: true,
                    storeRequired: true,
                    sideHidden: true,
                },
            },
            {
                path: "admin",
                component: setViewResolver("admin/Admin"),
                name: "AdminList",
                beforeEnter: storeSet,
                meta: {
                    name: "AdminList",
                    title: "관리자 목록",
                    sideName: "관리자 목록",
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    },
    {
        path: "/store",
        component: setViewResolver("RouteView"),
        name: "Store",
        meta: {name: "Store", sideName: "코인 스토어 관리", title: "코인 스토어 관리"},
        children: [
            {
                path: "list",
                component: setViewResolver("store/Store"),
                name: "Store",
                beforeEnter: storeSet,
                meta: {
                    name: "Store",
                    title: "상품 목록",
                    sideName: "상품 목록",
                    authRequired: true,
                    storeRequired: true,
                },
            },
            {
                path: "trade",
                component: setViewResolver("store/StoreTrade"),
                name: "StoreTrade",
                beforeEnter: storeSet,
                meta: {
                    name: "StoreTrade",
                    title: "교환 내역",
                    sideName: "교환 내역",
                    authRequired: true,
                    storeRequired: true,
                },
            },
        ],
    }
];
